import { ValidationError, ViolationType } from '../Validation';

export default class RuleViolationMapper {
  public static toDomain = (dto: CoreServiceAPI.RuleViolationDto): ValidationError => ({
    message: dto.violationMessage,
    fixable: dto.fixable,
    type: dto.type as ViolationType,
    articleNumber: dto.articleNumber,
  });

  public static toDto = (domain: ValidationError): CoreServiceAPI.RuleViolationDto => ({
    fixable: domain.fixable,
    type: domain.type as 'LIMIT' | 'STABILITY' | 'LIGHTING' | 'DISCONTINUED_ARTICLES',
    violationMessage: domain.message,
    articleNumber: domain.articleNumber,
  });
}
